import { LimitPeriod } from "@obg/ngx.common";

export const LIMIT_PERIOD_VALUE: Record<LimitPeriod, number> = {
	[LimitPeriod.Daily]: 1,
	[LimitPeriod.Weekly]: 7,
	[LimitPeriod.Monthly]: 30,
};

export const BETTING_LIMIT_CHANGE_CLASS = "obg-m-betting-limit-change-alert";
export const BETTING_LIMIT_CHANGE_DIALOG_ID = "BETTING_LIMIT_CHANGE_DIALOG_ID";
